import actions from '../../constants/actionTypes';
import request from '../../utils/request';
import { startAppLoading, stopAppLoading } from '../../layout/actions';
import { isSuccess } from '../../utils/utils';
import { setGeneralError } from '../../layout/components/UniversalModal/actions';
import { trans } from '../../localization';
import { EnumBookingType, EnumPaymentMethod } from '../../constants/enum';

export function getProfile() {
  return dispatch =>
    request.getNowShip('/api/user/get_profile').then(response => {
      if (isSuccess(response)) {
        return { userProfile: response.reply };
      }
      dispatch(setGeneralError(trans(response.result)));
      return { userProfile: {} };
    });
}

export function getMetadataNowShip(isLoading = true) {
  return dispatch => {
    if (isLoading) {
      dispatch(startAppLoading());
    }
    const requestList = [
      dispatch(getProfile()),
      request.getNowShip('/api/meta/get_metadata').then(response => {
        if (isSuccess(response)) {
          const { reply: metadata } = response;
          return { metadata };
        }
        dispatch(setGeneralError(trans(response.result)));
        return { metadata: {} };
      }),
    ];
    return Promise.all(requestList).then(responseList => {
      const initData = responseList.reduce(
        (mergeObject, item) => ({ ...mergeObject, ...item }),
        {},
      );
      dispatch({
        type: actions.RECEIVE_INIT_DATA_NOW_SHIP,
        response: initData,
      });
      if (isLoading) {
        dispatch(stopAppLoading());
      }
    });
  };
}

export async function getCommissionFeeConfig(restaurant, paymentMethod) {
  const response = await request.getNowShip(
    '/api/booking/get_commission_fee_config_v2',
    {
      booking_type: EnumBookingType.SHIPPING_MERCHANT.id,
      referral_id: restaurant.restaurant_id,
      city_id: restaurant.city_id,
      payment_method: paymentMethod,
    },
  );
  if (isSuccess(response)) {
    return response.reply;
  }
  throw response.result;
}

export function getCommissionFeeConfigChangePaymentMethod(paymentMethod) {
  return async (dispatch, getState) => {
    const state = getState();
    const { currentRestaurant } = state.ship.general;
    dispatch(startAppLoading());
    try {
      const commissionFeeConfig = await getCommissionFeeConfig(
        currentRestaurant,
        paymentMethod,
      );
      dispatch({
        type: actions.CHANGE_CURRENT_RESTAURANT_NOW_SHIP,
        response: {
          restaurant: { ...currentRestaurant, commissionFeeConfig },
        },
      });
      dispatch(stopAppLoading());
    } catch (e) {
      dispatch(stopAppLoading());
      dispatch(setGeneralError(e));
    }

  };
}

export function changeCurrentRestaurantNowShip(
  restaurant,
  paymentMethod = EnumPaymentMethod.COD.id,
) {
  return dispatch =>
    request
      .postMerchant('/api/restaurant/get_basic_info', {
        restaurant_ids: [restaurant.restaurant_id],
      })
      .then(async response => {
        if (isSuccess(response)) {
          const [restaurantExtraInfo] = response.reply.restaurants;
          const newRestaurantInfo = {
            ...restaurant,
            ...restaurantExtraInfo,
          };
          const commissionFeeConfig = await getCommissionFeeConfig(
            newRestaurantInfo,
            paymentMethod,
          );
          dispatch({
            type: actions.CHANGE_CURRENT_RESTAURANT_NOW_SHIP,
            response: {
              restaurant: { ...newRestaurantInfo, commissionFeeConfig },
            },
          });
          return newRestaurantInfo;
        }
        dispatch(setGeneralError(response.result));
        return null;
      });
}



// WEBPACK FOOTER //
// ./foody/src/pages/NowShip/actions.js